import { get } from "../Config";


export function GetRestaurant() {
  return get({ url: `/api/impact/v1/restaurant`});
}
export function GetRestaurantBranch({ params = {} }) {
  return get({ url: `/api/impact/v1/restaurantBranch`,params});
}
